import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useCityFormSchema = () => {
  const { t } = useTranslation();

  return z.object({
    city: z.string(),
    zipcode: z.string().min(3, t('formErrors.zipcode')).max(10, t('formErrors.zipcode')),
  });
};

export type CityFormData = z.infer<ReturnType<typeof useCityFormSchema>>;

export const useCityForm = (initialData?: Partial<CityFormData>) => {
  const citySchema = useCityFormSchema();

  const form = useForm<CityFormData>({
    resolver: zodResolver(citySchema),
    defaultValues: {
      city: initialData?.city || '',
      zipcode: initialData?.zipcode || '',
    },
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
  });

  useEffect(() => {
    form.reset({
      city: initialData?.city || '',
      zipcode: initialData?.zipcode || '',
    });
  }, [form, initialData]);

  return {
    form,
  };
};
